import { render, staticRenderFns } from "./CourseContentsTemplate3.vue?vue&type=template&id=7c3df75b&"
import script from "./CourseContentsTemplate3.vue?vue&type=script&lang=js&"
export * from "./CourseContentsTemplate3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports